import { TeaBlocksError } from './../../TeaBlocksError';
import { AssemblyJoystick } from './AssemblyJoystick';
import { ReturnBlock } from "../ReturnBlock";

/**
 * Gets the y value from a joystick with a specific name. Does not create the joystick.
 */
export class JoyYStatusBlock extends ReturnBlock {
    joyName: string;

    constructor(id: string, joyName: string) {
        super(id)
        this.joyName = joyName;
    }

    /**
     * Returns the y value of joystick. I.e. the y value of '&joyName'
     * @param varEnv variable environment
     */
    evalBlock(varEnv: Map<string, any>) {
        let vName = '&' + this.joyName;

        if (!varEnv.has(vName)) throw new TeaBlocksError(`Joystick ${this.joyName} does not exist`, this.id);

        let joy: AssemblyJoystick = varEnv.get(vName);

        return joy.y;
    }
}